import NoticeCard from '@/components/notice-card';

const NoticeDetailPage = () => {
  return <NoticeCard />;
};

export default NoticeDetailPage;
